<script>
import {
  AisQueryRuleContext,
  AisQueryRuleCustomData,
  AisStateResults,
} from 'vue-instantsearch/vue3/es';
import Cards from './AlgoliaCards.vue';
import Pagination from './AlgoliaPagination.vue';

export default {
  name: 'AlgoliaResults',

  components: {
    pagination: Pagination,
    cards: Cards,
    AisStateResults,
    AisQueryRuleCustomData,
    AisQueryRuleContext,
  },

  props: {
    content: {
      type: Object,
      default: () => {},
    },

    locale: {
      type: String,
      default: 'en-US',
    },
  },

  data() {
    return {
      currentPage: 1,
      hitsPerPage: 0,
      transformRuleContexts: (ruleContexts) => {
        ruleContexts.push(this.locale.replace('-', '_'));
        return ruleContexts;
      },
      trackedFilters: {
        productLocale: () => [this.locale.replace('-', '_')],
      },
    };
  },

  methods: {
    showPagination(nbHits) {
      return nbHits > 20;
    },

    computedResults(items, customData, pageSize, page, queryID) {
      const currentPage = page + 1;
      const results = {
        hits: items,
        pageSize,
        currentPage,
        queryID,
      };
      if (customData && currentPage === 1) {
        results.userData = customData;
      }
      return results;
    },

    getTotalUserDataBanners(userData) {
      return Object.keys(userData?.[0]?.[this.locale.replace('-', '_')] || {})?.length || 0;
    },

    calculateCombinedHits(nbHits, userData) {
      return nbHits + this.getTotalUserDataBanners(userData);
    },
  },
};
</script>

<template>
  <ais-state-results>
    <template #default="{ state: { query }, results: { hits, pageSize, page, nbHits, userData, queryID } }">
      <div
        v-show="query.length > 0"
        class="results"
        :class="{ 'has-results': hits.length > 0 }"
      >
        <div class="results__container">
          <span
            v-if="!hits.length && query && !userData"
            class="no-results"
          >
            {{ content.noResultsFound }} <b>{{ query }}</b>
          </span>
          <div
            v-else
            class="results-found"
          >
            <span>
              {{ calculateCombinedHits(nbHits, userData) }} {{ content.resultsFound }}
            </span>
          </div>

          <ais-query-rule-context
            :tracked-filters="trackedFilters"
            :transform-rule-contexts="transformRuleContexts"
          />

          <ais-query-rule-custom-data>
            <template #item="{ item }">
              <cards
                :locale="locale"
                :results="computedResults(hits, item, pageSize, page, queryID)"
              />
            </template>
          </ais-query-rule-custom-data>

          <cards
            v-if="!userData"
            :locale="locale"
            :results="computedResults(hits, [], pageSize, page, queryID)"
          />
          <pagination :show-pagination="showPagination(nbHits)" />
        </div>
      </div>
    </template>
  </ais-state-results>
</template>

<style lang="scss" scoped>
.results {

  &.has-results {
    background: $color-gray;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
  }

  &__container {
    max-width: 1200px;
    margin: 0 auto;
  }
}

/*
  Algolia Style overrides
*/

.ais-StateResults {
  @include font-primary();
}

.results-found {
  display: flex;
  justify-content: flex-end;
  margin: 0 1rem 1rem;
}
</style>
